<template>
    <section class="app-main">
        <router-view  :key="key" />
    </section>
</template>

<script>
export default {
    name: "AppMain",
    computed: {
        key() {
            return this.$route.path;
        }
    },
};
</script>

<style scoped>
.app-main {
    display: flex;
    justify-content: center;
    min-height: 50vh;
    margin: 0 auto;
    width: 1200px;
}

@media screen and (max-width: 767px) {
    .app-main {
        width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/layout/app/components/AppMain.vue